import { getKaspiVersion } from '../kaspi/client'
import { createFetcher } from './fetcher'

const kaspiVersion = getKaspiVersion()
const fetcherInstance = createFetcher({ targetEnv: 'client', kaspiVersion })
export const { fetcher, setAuthorization, setRequestHeaders, removeAuthorization } = fetcherInstance
